var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$root.streamid && _vm.$root.password)?_c('Questions'):_c('Login',{on:{"do-login":_vm.doLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }